<template lang="pug">
div
  //- input(
    type="file"
    ref="geotiffFile"
    hidden
    @change="onFileChange"
    accept="image/tiff,.tif")
  lf-control-action(
    icon="mdi-view-grid-plus"
    :dense="dense"
    :title="titleMessage"
    @click="showModal()"
  )
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import LfControlAction from '@/components/geos/LfControlAction.vue';

export default {
  name: 'LoadVectorControl',

  components: {
    LfControlAction
  },

  props: {
    listLayers: {
      type: Array,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: true
    }
  },

  emits: [],

  data() {
    return {
      titleMessage: 'Agregar datos vectoriales (GEOJSON, KML, SHP, GPX o KMZ)'
    };
  },

  computed: {
    ...mapState('module', []),
  },

  mounted() {},

  methods: {
    ...mapMutations('ui', ['SHOW_DRAGGABLE_MODAL']),
    showModal() {
      this.SHOW_DRAGGABLE_MODAL({
        dialogTitle: this.titleMessage,
        componentName: 'VectorLayerPicker',
        width: '550',
        height: '400',
        properties: {
          map: this.$parent.mapObject,
          listLayers: this.listLayers,
        }
      });
    },
    findLayerControl() {
      let p = this.$parent;
      while (p) {
        if (p.$refs && p.$refs.lyControl) {
          return p.$refs.lyControl.mapObject;
        }
        p = p.$parent;
      }
      return null;
    },
  }
};
</script>

<style scoped>
</style>
